








































import { Component, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";

@Component({
  components: {
  },
})
export default class UserManagementList extends Vue {
  @Getter public role!: any;

}
